// extracted by mini-css-extract-plugin
module.exports = {"strikeout":"MillesimaPrice_strikeout__Ru76o","bold-600":"MillesimaPrice_bold-600__kLrqM"};